import { BaseService } from 'core/services';
import { BillingRouteService } from 'common/data';

class BillingService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new BillingRouteService());
	}

	importCharges = (fromDate, toDate) => {
		const url = this.routeService.importCharges(fromDate, toDate);
		return this.apiClient.post(url);
	};

	calculateUpcharges = () => {
		const url = this.routeService.calculateUpcharges();
		return this.apiClient.post(url);
	};

	findMatches = () => {
		const url = this.routeService.findMatches();
		return this.apiClient.get(url);
	};

	assign = assignments => {
		const url = this.routeService.assign();
		return this.apiClient.post(url, assignments);
	};

	unassign = (trackingNumber, carrier) => {
		const url = this.routeService.unassign(trackingNumber, carrier);
		return this.apiClient.post(url);
	};

	createInvoices = sellerIds => {
		const url = this.routeService.invoices();
		return this.apiClient.post(url, sellerIds);
	};

	findSentInvoices = () => {
		const url = this.routeService.invoices();
		return this.apiClient.get(url);
	};
}

export default BillingService;
